import { useEffect, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { ExpandableSectionProps } from './types';
import clsx from 'clsx';

export default function ExpandableSection({
  title,
  titleClassName = '',
  containerClassName = '',
  children,
  childrenClassName = '',
  defaultExpanded = false,
  forceExpanded = false,
}: ExpandableSectionProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  useEffect(() => {
    if (forceExpanded && !expanded) {
      setExpanded(true);
    }
  }, [expanded, forceExpanded]);

  return (
    <div className={clsx('w-full', containerClassName)}>
      <div
        className={clsx(
          'flex cursor-pointer items-center gap-3 pb-2',
          expanded && 'pb-4',
        )}
        onClick={() => setExpanded(forceExpanded ? true : !expanded)}
      >
        <h2 className={titleClassName}>{title}</h2>
        {expanded ? (
          <ChevronUp className="h-5 w-5" />
        ) : (
          <ChevronDown className="h-5 w-5" />
        )}
      </div>
      {expanded && <div className={childrenClassName}>{children}</div>}
      <hr className="mt-2" />
    </div>
  );
}
